export default __webpack_public_path__ + "static/media/dripsSlide1.0d81cd6f.png";